import React from 'react'

import { progress } from '@ui-kit/components/Progress/styles'
import { bgColor } from '@ui-kit/styles/colors'

import type { Props } from './types'

const Progress = (props: Props) => {
  const { container, bar } = progress({
    isStepper: props.isStepper,
    rounded: props.rounded,
  })

  return (
    <div className={container()}>
      <div
        className={bar({ className: bgColor({ color: props.barColor ?? 'brandDark' }) })}
        style={{ width: `${Math.round(props.value) || 0}%` }}
      />
    </div>
  )
}

export default Progress
